import React, {memo} from "react";
import ShareSocialIcons from "./ShareSocialIcons";

const styles = {
    root: {
        width: '35%',
        margin: '0 auto'
    },
    titleDiv: {
        fontSize: '1.2vw',
        fontFamily: 'DINPro-Bold',
        height: 'auto'
    },
    title: {
        padding: '10px 20px',
        lineHeight: '3vw'
    },
    closeIcon: {
        padding: '0 0.5vw',
        cursor: "pointer",
        lineHeight: '3vw'
    },
    bodyRoot: {
        padding: '0 3vw'
    },
    bodyText: {
        margin: '3.2vw auto',
        fontSize: '1.1vw',
        padding: '1vw 1.5vw'
    }
}

const SHARE_SAFE_MEASURING_TEXT = "Please keep Safe Management Measures in mind when uploading your photo for public viewing.";

const SharePhotoDialog = ({onClose}) => {
    return (<div className="coverup photobooth-cover termbox"
                 style={styles.root}>
        <div style={styles.titleDiv}>
            <span style={styles.title}>Share Your Photo!</span>
            <span className="pull-right"
                  style={styles.closeIcon}
                  onClick={onClose}>X</span>
        </div>
        <div style={styles.bodyRoot}>
            <ShareSocialIcons/>
            <div style={styles.bodyText}>{SHARE_SAFE_MEASURING_TEXT}</div>
        </div>
    </div>)
}

export default memo(SharePhotoDialog)